import { render } from "./TermsOfService.vue.js?vue&type=template&id=ff0d4746&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsOfService.vue?vue&type=template&id=ff0d4746&scoped=true"
import script from "./TermsOfService.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsOfService.vue?vue&type=script&lang=js"

import "./TermsOfService.vue.scss?vue&type=style&index=0&id=ff0d4746&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsOfService.vue?vue&type=style&index=0&id=ff0d4746&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0d4746"],['__file',"src/Web/scripts/pages/TermsOfService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff0d4746"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff0d4746', __exports__)) {
    api.reload('ff0d4746', __exports__)
  }
  
  module.hot.accept("./TermsOfService.vue.js?vue&type=template&id=ff0d4746&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsOfService.vue?vue&type=template&id=ff0d4746&scoped=true", () => {
    api.rerender('ff0d4746', render)
  })

}


export default __exports__